import DialogCustom from "./DialogCustom";

export default DialogCustom;